import * as variables from '@/assets/js/variables';
import config from '@/assets/styles/config';

const attachVariables = (Vue, variables, wrappingObject, excludedVariables = []) => {
  const filteredKeys = Object.keys(variables).filter(key => !excludedVariables.includes(key));
  const object = filteredKeys.reduce((total, key) => {
    return Object.defineProperty(total, key, {
      value: Object.freeze(variables[key]),
    });
  }, {});
  Object.assign(Vue.prototype, { [`$_${wrappingObject}`]: object });
};

export default {
  install(Vue) {
    attachVariables(Vue, variables, 'config');
    attachVariables(Vue, config.colors, 'colors');
  },
};
